import React, { Component } from 'react';
import PropTypes from 'prop-types';

class ItemList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { items, title, isScrollable } = this.props;
    if(items && items.length > 0 && items[0] !== null) {
      return (
        <section className={`fe-trip-item-list ${(isScrollable) ? 'scrollable' : ''}`}>
          <div className="container">
            <div className="row">
              {/* <div className="col-lg-8"> */}
              <h4 className="fe-trip-main-heading">{ title }</h4>
              <div className="fe-trip-item-list-content">
                <ul>
                  {items.map((item, idx) => (
                    <li key={idx}>{item}</li>
                  ))}
                </ul>
              </div>
              {/* </div> */}
            </div>
          </div>
        </section>
      );
    }
    return null;
  }
}

ItemList.propTypes = {
  items: PropTypes.array,
  title: PropTypes.string,
  isScrollable: PropTypes.bool
};

export default ItemList;
